import { BannerSchema } from '@/components/Banner/style/Banner.styles';

export const bannerStyles: BannerSchema = {
  bannerBoxProps: {
    bgGradient: 'linear(to-b, beta.400, beta.500)',
    borderRadius: 'base',
    border: 'none',
    gap: '3',
  },
  depositIconProps: {
    color: 'beta.800',
    boxSize: '9',
  },
};
